import React from "react";
import { Statistic } from "../Statistic/Statistic";
import { StatsNumbersBlockValues } from "../../types/optimizely/blocks";
import { SectionHeading } from "../SectionHeading/SectionHeading";
import Link from "../Link/Link";

interface StatisticsProps {
  content: StatsNumbersBlockValues;
}

const StatisticsBlock: React.FC<StatisticsProps> = ({ content }) => {
  const {
    title,
    buttonLink,
    buttonTitle,
    statsNumbersContentArea,
  } = content;

  const contentArray = statsNumbersContentArea?.expandedValue || [];

  return (
    <div className="bg-primaryTurquoise">
      <section className="px-[60px] py-8 text-left flex flex-col items-center">
        {Boolean(title.value) && (
          <div className="w-full">
            <SectionHeading title={title.value} colorVariant="primary" />
          </div>
        )}

        <ul className={`grid grid-cols-1 lg:grid-cols-${contentArray.length} w-full divide-y lg:divide-x lg:divide-y-0 divide-primary mt-4`}>
          {contentArray.map((content, idx) => (
            <Statistic
              key={idx}
              number={content.number.value}
              title={content.title.value}
              introduction={content.introduction.value}
              total={contentArray.length}
              className="[&:not(:first-child)]:pt-6 md:[&:not(:first-child)]:pt-0 px-4 lg:px-6 md:[&:first-child]:pl-0 md:[&:last-child]:pr-0"
            />
          ))}
        </ul>

        {Boolean(buttonTitle.value) && (
          <Link
            text={buttonTitle.value}
            variant="main"
            href={buttonLink.value}
            className="mt-9 w-full md:w-auto"
          />
        )}
      </section>
    </div>
  );
};

export default StatisticsBlock;